import { useCallback, useContext } from 'react';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { MuroDepContext } from '@wix/da-react-context/pkg/MuroDepContext';
import { PapiDeviation } from '@wix/da-papi-types';
import { ModalType } from '../../Modals/redux/types';
import { usePushModal } from './usePushModal';

export function usePushMiniMuroModal(deviation?: PapiDeviation): () => void {
  const { MiniComponent } = useContext(MuroDepContext);
  const pushMiniMuroModal = usePushModal(ModalType.MINI_MURO);

  return useCallback(() => {
    yieldToMain(() => {
      if (MiniComponent) {
        pushMiniMuroModal({
          miniComponent: MiniComponent,
          deviation,
          canvasSize: 1152,
          aspectRatio: '4:3',
        });
      }
    });
  }, [pushMiniMuroModal, MiniComponent, deviation]);
}

export function usePushMobileMuroModal(deviation?: PapiDeviation): () => void {
  const { MobileComponent } = useContext(MuroDepContext);
  const pushMobileMuroModal = usePushModal(ModalType.MOBILE_MURO);

  return useCallback(() => {
    yieldToMain(() => {
      if (MobileComponent) {
        pushMobileMuroModal({
          mobileComponent: MobileComponent,
          deviation,
          canvasSize: 1152,
          aspectRatio: '4:3',
        });
      }
    });
  }, [MobileComponent, pushMobileMuroModal, deviation]);
}

export function usePushMiniMobileMuroModal(
  deviation?: PapiDeviation
): () => void {
  const { MobileComponent } = useContext(MuroDepContext);
  const pushMobileMuroModal = usePushModal(ModalType.MINI_MOBILE_MURO);

  return useCallback(() => {
    yieldToMain(() => {
      if (MobileComponent) {
        pushMobileMuroModal({
          mobileComponent: MobileComponent,
          deviation,
          canvasSize: 1152,
          aspectRatio: '4:3',
        });
      }
    });
  }, [MobileComponent, pushMobileMuroModal, deviation]);
}
